module.exports = __webpack_public_path__ + "img/07.20c62efa.png";